import { setupLazyLoadImage } from './EmblaCarouselLazyLoad'
//import { addDotBtnsAndClickHandlers } from './EmblaCarouselDotButton'
import { addPrevNextBtnsClickHandlers } from './EmblaCarouselArrowButtons'
import { updateSelectedSnapDisplay } from './EmblaCarouselSelectedSnapDisplay'

const elements = document.querySelectorAll('.embla');


for (let i = 0; i < elements.length; i++) {
    const emblaNode = elements[i];
    const options = { loop: false };

    const viewportNode = emblaNode.querySelector('.embla__viewport')

    const prevBtn = emblaNode.querySelector('.embla__button--prev')
    const nextBtn = emblaNode.querySelector('.embla__button--next')

    //const dotsNode = emblaNode.querySelector('.embla__dots')

    const snapDisplayNode = emblaNode.querySelector('.embla__selected-snap-display')

    const emblaApi = EmblaCarousel(viewportNode, options)
    const loadImagesInView = setupLazyLoadImage(emblaApi)

    updateSelectedSnapDisplay(emblaApi, snapDisplayNode)

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
        emblaApi,
        prevBtn,
        nextBtn
    )

    /*
    const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
        emblaApi,
        dotsNode
    )
     */

    emblaApi
        .on('init', loadImagesInView)
        .on('reInit', loadImagesInView)
        .on('slidesInView', loadImagesInView)
        .on('destroy', removePrevNextBtnsClickHandlers)
        //.on('destroy', removeDotBtnsAndClickHandlers)
}

if (elements.length > 0) {
    // Source: https://biati-digital.github.io/glightbox/
    const lightbox = GLightbox({
        loop: false,
        preload: false,
        keyboardNavigation: false,
    });

    // @TODO needs work for multiple sliders on a page
    /*
    lightbox.on('slide_changed', ({ prev, current }) => {
        console.log('Prev slide', prev);
        console.log('Current slide', current);

        if (current.slideIndex < prev.slideIndex) {
            //emblaApi.scrollPrev(true)
        } else {
            //emblaApi.scrollNext(true)
        }
    });
    */
}
